export const CONFIG_TRAILBORN = {
  styles: `
    :host {
      --sb-modal-radius: 10px;
      --sb-widget-padding: 0px;
      --sb-widget-radius: 30px;
    }
    .widget--inner {
      align-items: stretch;
      height: 72px;
      width: 100%;
    }
    .trigger-row {
      display: grid;
      flex: none;
      padding: 0;
      grid-template-columns: 1fr 1fr 1fr;
      width: 75%;
    }
    .trigger-div,
    .btn-trigger {
      height: 100%;
    }
    .trigger-row > :is(.btn-trigger, .trigger-div) {
      border: 1px solid #1A1A1A;
      border-right: 0 none;
    }
    .btn-trigger {
      border-radius: 0;
      justify-content: flex-start;
      padding: 10px 24px;
      width: 100%;
    }
    .btn-trigger > div {
      display: block;
      text-align: left;
    }
    .btn-trigger--destination {
      border-bottom-left-radius: var(--sb-widget-radius, 0);
      border-top-left-radius: var(--sb-widget-radius, 0);
    }
    .btn-trigger--destination > div {
      margin-right: 0;
      width: calc(100% - 20px);
    }
    .trigger__btn-text {
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
    }
    .btn--submit,
    .widget-mobile {
      border: 1px solid #1A1A1A;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 2px;
      text-transform: uppercase;
    }
    .btn--submit {
      border-radius: 0;
      border-bottom-right-radius: var(--sb-widget-radius, 0);
      border-top-right-radius: var(--sb-widget-radius, 0);
      flex: none;
      height: 72px;
      width: 25%;
    }
    .widget-mobile {
      border-radius: 10px;
      height: 56px;
    }
    .destination__padder {
      padding: 14px 16px;
    }
    .popout--calendar {
      left: auto;
      right: 0;
    }
    @media all and (width < 993px) {
      .mobile-only {
        display: var(--mobile-display, block);
      }
      .desktop-only {
        display: none;
      }
    }
  `,
  fontFamily: '"FT Regola Neue", Arial, sans-serif',
  triggers: {
    order: ['destination', 'guests', 'calendar'],
    showIconLeft: true,
    showIconRight: true,
    type: 'labeled',
    labels: {
      destination: 'I want to stay at Trailborn',
      guests: 'With',
      calendar: 'During',
    },
  },
  primaryColor: '#FFC799',
  calendar: {
    showPrices: true,
  },
  theme: {
    ui: {
      button: {
        ghost: {
          light: {
            active: '#FFEEE0',
            hover: '#FFEEE0',
          },
        },
        primary: {
          light: {
            disabled: '#FFC799',
            disabledText: '#1A1A1A',
            text: '#1A1A1A',
          }
        }
      },
      calendar: {
        light: {
          arrDepText: '#1A1A1A',
          dayBkgActive: '#FFEEE0',
          dayBkgHover: '#FFEEE0',
        },
      },
    },
    tokens: {
      heading: {
        "compact-01": {
          letterSpacing: 0.24,
        },
        "01": {
          letterSpacing: 0.24,
        },
        "03": {
          letterSpacing: 0.16,
        },
        "05": {
          letterSpacing: -0.16,
        },
        "07": {
          letterSpacing: -0.48,
        },
      },
    },
  },
};
